<template>
  <div id="CandidatoForm" class="container">
    <div class="box-loading">
      <div class="loading" v-if="$store.state.loading">
        <img src="@/assets/loading.gif" alt="Carregando..." title="Carregando..." />
      </div>
      <h2>Formulário de admissão</h2>
    </div>

    <form @submit.prevent="submit">
      <h2>Dados Pessoais</h2>
      <InputDadosPessoais ref="dadosPessoais" :dadosPessoais="form.dados_pessoais" />

      <h2>Dados de endereço</h2>
      <InputDadosEndereco ref="dadosEndereco" :candidatoDb="candidatoDb" :dadosDocumentacao="form.dados_documentacao"
        :dadosEndereco="form.dados_endereco" />

      <h2>Dados de documentação</h2>
      <InputDadosDocumentacao ref="dadosDocumentacao" :dadosDocumentacao="form.dados_documentacao"
       />

      <h2>Dados bancários</h2>
      <InputDadosBancarios ref="dadosBancarios" :dadosBancarios="form.dados_bancarios" />

      <h2>Dependentes Legais</h2>
      <div class="form-control">
        <label for="cf_count_dependentes">Dependentes:</label>
        <input type="range" id="cf_count_dependentes" name="cf_count_dependentes" min="0" max="10"
          v-model="count_dependentes" @change="add_dependente()" />
        <span>{{ count_dependentes }}</span>
      </div>

      <div class="box_dependentes">
        <InputDependente ref="dependente" v-for="(input, index) in dependentes" :key="index" :id-data="index"
          :dependente="input.dependente" :dadosDependentes="form.dados_dependentes"  :estado-civil="form.dados_pessoais.estado_civil" />
      </div>

      <InputAnexos ref="anexos" :dadosPessoais="form.dados_pessoais" :anexosCandidato="form.anexos_candidato"
        :candidatoExiste="candidatoExiste" :dadosDocumentacao="form.dados_documentacao"
        :dadosBancarios="form.dados_bancarios" />

      <!-- Campo para pular validação de PDF com senha - aparece quando parâmetro skipPdf=1 estiver na URL -->
      <div class="form-control skip-pdf-validation" v-if="showSkipPdfValidation">
        <div class="checkbox-wrapper">
          <input type="checkbox" id="cf_skip_pdf_validation" name="cf_skip_pdf_validation" 
                 v-model="form.skip_pdf_validation" />
          <label for="cf_skip_pdf_validation" class="checkbox-label">
            Desativar validação dos anexos
          </label>
        </div>
        <p class="help-text">
          Marque esta opção se você possui documentos em PDF protegidos por senha e deseja continuar sem a validação automática.
        </p>
      </div>

      <div class="form-control">
        <button type="submit">Enviar formulário</button>
      </div>
    </form>

    <loading v-if="$store.state.loadingSave" />
    <alert v-if="$store.state.alert.show" />
  </div>
</template>
<script>
import { mask } from "vue-the-mask";
import InputDadosPessoais from "./InputDadosPessoais";
import InputDadosEndereco from "./InputDadosEndereco";
import InputDadosDocumentacao from "./InputDadosDocumentacao";
import InputDadosBancarios from "./InputDadosBancarios";
import InputDependente from "./InputDependente";
import InputAnexos from "./InputAnexos";
import mixins from "@/assets/mixins";
import Loading from "../commons/Loading.vue";
import Alert from "../commons/Alert.vue";

export default {
  directives: { mask },
  mixins: [mixins],
  components: {
    InputDadosEndereco,
    InputDadosPessoais,
    InputDadosDocumentacao,
    InputDadosBancarios,
    InputDependente,
    InputAnexos,
    Loading,
    Alert,
  },
  async created() {
    //define o papel
    this.role = this.$route.meta.role;
    this.key = this.$route.params.key;

    var base64regex =
      /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;

    if (base64regex.test(this.key)) {
      this.keyDecoded = atob(this.key);
    } else {
      this.keyDecoded = this.key;
      if (process.env.NODE_ENV === "development") {
        this.key = btoa(this.key);
      }
    }

    //Verifica se a key é valida e o formulário ainda não foi preenchido
    this.verifica_key();

    //Carrega as ufs
    await this.$store.dispatch("load-ufs");
    await this.$store.dispatch("load-municipios");

    // Verifica se deve mostrar o campo de skip PDF validation baseado no parâmetro da URL
    this.showSkipPdfValidation = this.$route.query.skipPdf === '1';

    // Evento para salvar os campos do formulário no localstorage
    window.addEventListener("beforeunload", () => {
      var form = document.querySelector("form");
      const elements = form.elements;
      var data = this.serialize(form);

      // Formata os dependentes
      data.dependentes = this.get_dependentes(data);
      data.key = this.key;
      data.role = this.role;

      if (data.cf_numero_da_conta) {
        data.cf_numero_da_conta = data.cf_numero_da_conta.replace(/\D/g, "");
      }

      // Salva os dados no localstorage
      localStorage.setItem("form", JSON.stringify(data));
      event.returnValue = "Voce quer mesmo sair?"; // workaround pra compatibilidade de navegadores
      return "voce quer mesmo sair";
    });

    // Carrega os dados do localstorage se o role for candidato
    // e se os dados nas foram carregados do banco de dados
    if (!this.candidatoExiste) {
      setTimeout(() => {
        this.carrega_formulario_localstorage();
      }, 500);
    }
  },
  data: () => ({
    pisPasepValido: false, // novo
    count_dependentes: 0, // Default dependentes
    dependentes: [], //
    role: null,
    key: null,
    keyDecoded: null,
    candidatoExiste: false,
    debug: false,
    cepError: "",
    candidatoDb: null, // Dados do candidato que retornam do banco
    showSkipPdfValidation: false, // Controla se mostra o campo de skip PDF
    config: {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
    },
    form: {
      dados_pessoais: {
        estado_civil: "",
        pcd: "",
        aposentado: "",
        sexo: "",
        email: "",
        data_do_casamento: "",
      },
      dados_bancarios: {
        banco: "",
        conta_salario: "",
      },
      dados_endereco: {
        cep: "",
        cidade: "",
      },
      dados_documentacao: {
        estrangeiro: "nao",
        naturalizado: "",
        numero_rne: "",
        orgao_emissor_rne: "",
        casado_brasileiro: "",
        filho_brasileiro: "",
        classificacao_estrangeiro: "",
        tempo_residencia: "",
        data_expedicao_rne: "",
        data_validade_rne: "",
        cpf: "",
        pisPasep: "",
      },
      anexos_candidato: [],
      dados_dependentes: [],
      skip_pdf_validation: false, // Flag para pular validação de PDF
    },
    extensoes_arquivos_validos: [
      "image/jpg",
      "image/png",
      "application/pdf",
      "image/jpeg",
    ],
  }),
  methods: {
    validateDataCasamento() {
      if (this.form.estado_civil !== "casado") {
        this.dataCasamentoError = "";
        return true;
      }

      const data = new Date(this.form.data_do_casamento);
      const hoje = new Date();
      hoje.setHours(0, 0, 0, 0);

      if (!this.form.data_do_casamento) {
        this.dataCasamentoError = "Data do casamento é obrigatória";
        return false;
      } else if (isNaN(data.getTime())) {
        this.dataCasamentoError = "Data inválida";
        return false;
      } else if (data > hoje) {
        this.dataCasamentoError = "A data não pode ser futura";
        return false;
      }

      this.dataCasamentoError = "";
      return true;
    },
    validateForm() {
      // const emailOk = this.validateEmail();
      const dataOk = this.validateDataCasamento();

      // foco no primeiro campo inválido
      // if (!emailOk) {
      //   this.$refs.emailInput?.focus();
      //   return false;
      // }

      if (!dataOk) {
        this.$refs.dataCasamentoInput?.focus();
        return false;
      }

      return true;
    },
    async converte_arquivo_para_base64(arquivo) {
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(arquivo);
        fileReader.onload = () => resolve(fileReader.result);
        fileReader.onerror = (error) => reject(error);
      });
    },
    arquivo_de_imagem_eh_valido(extensao_arquivo) {
      // console.log(extensao_arquivo);
      if (!extensao_arquivo) {
        return false;
      }
      if (!this.extensoes_arquivos_validos.includes(extensao_arquivo)) {
        return false;
      }
      return true;
    },
    async prepara_arquivos_para_envio(input_arquivos) {
      let upload_arquivos = {};
      for (var input_arquivo of input_arquivos) {
        var files = input_arquivo.files;
        if (!files || files.length === 0) {
          continue;
        }

        for (var i = 0; i < files.length; i++) {
          var file = files[i];

          if (!this.arquivo_de_imagem_eh_valido(file?.type)) {
            alert(`arquivo ${file.name} inválido`);
            return;
          }

          const dadosAnexoBase64 = await this.converte_arquivo_para_base64(
            file
          );
          if (!upload_arquivos[input_arquivo.name]) {
            upload_arquivos[input_arquivo.name] = [];
          }
          upload_arquivos[input_arquivo.name].push({
            nome: file.name,
            data: dadosAnexoBase64,
          });
        }
      }
      return upload_arquivos;
    },
    formata_dados_para_envio(data) {
      let dados_formatados = {};

      // remove dependentes da raiz do objeto
      for (const key in data) {
        // Filtra os campos de dependentes
        if (key.indexOf("cf_dependente") == -1) {
          dados_formatados[key] = data[key];
        }
      }
      return dados_formatados;
    },
    //Método para adicionar dependentes (tem que rever esse trecho depois, não está correto)
    add_dependente(dependente) {
      this.dependentes = [];

      if (dependente == undefined) {
        dependente = {
          nome_completo: null,
        };
      }

      for (let i = 0; i < this.count_dependentes; i++) {
        this.dependentes.push({
          id: `${this.count_dependentes + 1}`,
          dependente: dependente,
        });
      }
    },
    //Função para verificar se a key é valida e se o formulário não foi preenchido ainda
    verifica_key() {
      console.info(`[verifica_key] key: ${this.keyDecoded}`);

      if (this.key == "123") return false;

      // Exibe o loading
      this.$store.dispatch("change-loading", true);

      let config = {
        method: "get",
        url: `/api/admission-form/key/${this.key}`,
      };

      this.axios
        .request(config)
        .then((response) => {
          const statusCode = response.status;

          // Caso não tenha inserido, prossegue com o preenchimento
          if (statusCode === 200) {
            return true;
          } else {
            alert("Erro ao verificar formulário!");
          }
        })
        .catch((error) => {
          const statusCode = error.response?.status;
          const statusSWorks = error.response?.data?.data?.statusSWorks;

          // Caso o formulário já tenha sido inserido, é redirecionado para a página finalizado
          if (
            statusCode === 409 &&
            this.role === "candidato" &&
            !this.debug &&
            !statusSWorks
          ) {
            this.$router.push("/finalizado");
            return;
          }

          // Se o formulário já está cadastrado, carrega os dados dele
          // if (statusCode === 409 && this.role === "dp") {
          if (statusCode === 409) {
            (this.candidatoExiste = true),
              setTimeout(() => {
                this.carrega_formulario();
              }, 2000);
            return;
          }

          // Exibe o alerta de erro
          if (statusCode !== 409) {
            alert("Erro ao verificar formulário!");
            return;
          }
        })
        .finally(() => {
          // Oculta o loading
          this.$store.dispatch("change-loading", false);
        });

    },
    //Função para validar o submit do formulário e trazer informações dependentes
    async submit(e) {
      e.preventDefault();

      // console.log(this.$refs);

      const cepValido = this.$refs.dadosEndereco.validateCEP(true);
      if (!cepValido) {
        alert("CEP inválido.");
        return;
      }

      const isCpfValid = this.$refs.dadosDocumentacao.validateCPF(true);
      if (!isCpfValid) {
        alert("CPF inválido.");
        return;
      }

      const isPisValid = this.$refs.dadosDocumentacao.validatePisPasep(true);
      if (!isPisValid) {
       alert("PIS/PASEP inválido.");
        return;
     }

      const isValid = this.$refs.dadosPessoais.validateEmail(true);
      if (!isValid) {
        console.log("E-mail inválido.");
        // interrompe o submit
        return;
      }
      
      //salvar formulario

      // const isValidDadosPessoais = this.$refs.dadosPessoais.validateForm(true);
      // if (!isValidDadosPessoais) return;
      var form = document.querySelector("form");

      // pegar input file
      var input_arquivos = document.querySelectorAll("input[type=file]");
      var upload_arquivos = await this.prepara_arquivos_para_envio(
        input_arquivos
      );

      if (!upload_arquivos) {
        alert("Erro ao preparar os arquivos para envio.");
        return false;
      }

      //Pega os valores de todos os campos por id
      var data = this.serialize(form);
      data.key = this.key;
      data.role = this.role;
      
      // Inclui a flag de skip PDF validation se estiver marcada
      if (this.showSkipPdfValidation && this.form.skip_pdf_validation) {
        data.skipPdfValidation = true;
      }

      Object.assign(data, { ...upload_arquivos });

      // Formata os dependentes
      data.dependentes = this.get_dependentes(data);

      const dados_formatados = this.formata_dados_para_envio(data);
      this.salvar_formulario(dados_formatados);

    },
    //Salva o formulário
    salvar_formulario(data) {
      this.$store.dispatch("change-loading-save", true);

      let config = {
        method: "post",
        url: "/api/admission-form/",
        headers: {
          "Content-Type": "application/json",
          // 'Content-Type': 'multipart/form-data'
        },
        data: data,
      };

      this.axios
        .request(config)
        .then((response) => {
          // TODO tirar quando subir para teste
          if (response.data.status) {
            if (this.role == "candidato") {
              // Redireciona para a página de finalizado
              this.$store.dispatch("change-alert", {
                show: true,
                type: "success",
                message: "Formulário atualizado com sucesso!",
                callback: () => {
                  this.$router.push("/finalizado");
                },
              });

              // Limpa o localstorage
              localStorage.removeItem("form");
            } else if (this.role == "dp") {
              // Redireciona para a página de finalizado
              this.$store.dispatch("change-alert", {
                show: true,
                type: "success",
                message: "Formulário atualizado com sucesso!",
              });
            }
          } else {
            // alert("Erro ao salvar o formulário! Tente novamente.");
            this.$store.dispatch("change-alert", {
              show: true,
              type: "error",
              message: "Erro ao salvar o formulário! Tente novamente.",
            });
            console.error(response.data.message);
            // alert(response.data.message);
          }
        })
        .catch((error) => {
          const responseData = error.response?.data;
          let message =
            responseData?.message ||
            responseData?.data?.message ||
            error.message ||
            "Erro desconhecido ao salvar o formulário";

          console.error("[salvar_formulario] falha ao salvar candidato", {
            status: error.response?.status,
            data: responseData,
            message,
          });
          
          // Verifica se o erro é relacionado a PDF protegido e adiciona link para tentar novamente com skip
          const isPdfError = this.isPdfProtectedError(message);
          let errorMessage = `Erro ao salvar o formulário! Tente novamente. <br/>${message || "Erro desconhecido"}`;
          
          if (isPdfError && !this.showSkipPdfValidation) {
            const currentUrl = window.location.href;
            const separator = currentUrl.includes('?') ? '&' : '?';
            const newUrl = `${currentUrl}${separator}skipPdf=1`;
            
            errorMessage += `<br/><br/><a href="${newUrl}" style="color: #fa4616; text-decoration: underline;">Clique aqui para tentar novamente permitindo PDFs protegidos por senha</a>`;
          }
          
          this.$store.dispatch("change-alert", {
            show: true,
            type: "error",
            message: errorMessage
          });
        })
        .finally(() => {
          this.$store.dispatch("change-loading-save", false);
        });
    },
    //Formata os dependentes
    get_dependentes(data) {
      var index = [];

      // Loop em torno os campos
      for (const key in data) {
        // Filtra os campos de dependentes
        if (key.indexOf("cf_dependente") == -1) {
          continue;
        }

        let split = key.split("_"); // Quebra a string aonde tem underline
        let id = split[split.length - 1]; // pega o ultimo número da string para usar como id
        split.pop(); // remove o ultimo elemento que é a id usada
        let key_no_id = split.join("_"); // gera uma nova key sem o id

        // Verifica se é um novo index
        if (typeof index[id] === "undefined") {
          index[id] = {};
        }

        //Adiciona o valor do campo ao index junto com a key
        index[id][key_no_id] = data[key];
      }

      return index;
    },
    //Carrega os dados do formulário
    carrega_formulario() {
      this.$store.dispatch("change-loading", true);

      //Params
      const data = {
        key: this.key,
        role: this.role,
      };

      let config = {
        method: "get",
        url: `/api/admission-form/${this.key}`,
      };

      this.axios(config)
        .then((response) => {
          if (!response.data.status) {
            alert(response.data.message);
          }

          //Receive data
          const data = response.data.data;
          var form = document.querySelector("form");

          const elements = form.elements;
          const { anexos: anexosCandidato } = data.candidato;

          this.candidatoDb = data.candidato;

          //Fixa o valor padrão nos campos por id
          for (let i = 0, element; (element = elements[i++]);) {
            var chave_field = element.id?.replace("cf_", "")?.trim();
            var new_value = data?.candidato?.[chave_field];

            // console.log(
            //   `[carrega_formulario] element: ${element.id}, new_value: ${new_value}`
            // );

            //Se o valor não for invalido e o campo existir
            if (new_value && element.id) {
              // tratamento para campos boolean
              element.value =
                typeof new_value == "boolean"
                  ? new_value === true
                    ? "sim"
                    : "nao"
                  : new_value;
            }
          }
          this.form.anexos_candidato = anexosCandidato;
          this.form.dados_pessoais.email = this.candidatoDb.email || "";

          /** documentação */
          this.form.dados_documentacao.cpf = this.candidatoDb.cpf || "";
          this.form.dados_documentacao.pisPasep = this.candidatoDb.pis_pasep || "";
          this.form.dados_documentacao.estrangeiro = this.candidatoDb.estrangeiro || "nao";

          /** Endereço */
          this.form.dados_endereco.cep = this.candidatoDb.cep || "";
          this.form.dados_documentacao.estado_nascimento = this.candidatoDb.estado_nascimento || "";
          this.form.dados_documentacao.cidade_nascimento = this.candidatoDb.cidade_nascimento || "";

          /** Dados pessoais */
          this.form.dados_dependentes = data.dependentes; // dependentes que já foram cadastrados no bd
          this.form.dados_pessoais.estado_civil = data.candidato.estado_civil; //Define estado civil
          this.form.dados_pessoais.sexo = data.candidato.sexo;
          this.form.dados_pessoais.pcd = !data.candidato.pcd ? "nao" : "sim";
          this.form.dados_pessoais.aposentado = !data.candidato.aposentado
            ? "nao"
            : "sim";
          this.form.dados_pessoais.data_do_casamento = data.candidato.data_do_casamento || "";

          /** Dados bancários */
          this.form.dados_bancarios.banco =  data.candidato.banco == "1" ? "sim" : "nao";
          this.form.dados_bancarios.conta_salario = data.candidato.conta_salario || "nao";

          this.count_dependentes = data.dependentes.length;

          for (const i in data.dependentes) {
            const dependente = data.dependentes[i];
            this.add_dependente(dependente);
          }

          //POG para rodar somente depois que o formulário foi executado
          setTimeout(() => {
            // Loop nos dependentes
            for (const i in data.dependentes) {
              const dependente = data.dependentes[i];

              //Loop nas chaves do objeto dependente
              for (const key in dependente) {
                let id = `cf_dependente_${key}_${i}`;
                let el = document.getElementById(id);

                // verifica se o existe
                if (el) {
                  el.value = dependente[key];
                }
              }

              //POG: para o campo de dependente ir porque
              //a nomeclatura é diferente dos demais campos
              document.getElementById("cf_dependente_ir_" + i).value =
                !dependente.dependente_ir ? "nao" : "sim";
            }

            //Fixa o valor padrão nos campos por id
            for (let i = 0, element; (element = elements[i++]);) {
              var new_value = data[element.id.replace("cf_", "")];

              //Se o valor não for invalido e o campo existir
              if (new_value && element.id) {
                element.value = new_value;
              }
            }

          }, 3000);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.$store.dispatch("change-loading", false);
        });
    },
    carrega_formulario_localstorage() {
      return false;

      if (this.role != "candidato") {
        return false;
      }
      var data = localStorage.getItem("form");
      if (!data) {
        return false;
      }

      data = JSON.parse(data);

      var formData = document.querySelector("form");
      if (!formData) {
        // debugger;
        return false;
      }
      const elements = formData.elements;
      //Fixa o valor padrão nos campos por id
      for (const element of elements) {
        // Nome do campo, basicamente com o cf_ na frente
        var new_value = data[element.id];

        // Nome interno do campo
        var element_id = element.id.replace("cf_", "");

        //Se o valor não for invalido e o campo existir
        if (new_value && element.id) {
          element.value = new_value;
        }
      }

      // Define estado civil
      this.form.dados_pessoais.estado_civil = data.cf_estado_civil;
      // Define sexo
      this.form.dados_pessoais.sexo = data.cf_sexo;
      // Define PCD
      this.form.dados_pessoais.pcd = data.cf_pcd;
      // Define Aposentado
      this.form.dados_pessoais.aposentado = data.cf_aposentado;
      // Estrangeiro
      this.form.dados_documentacao.estrangeiro = data.cf_estrangeiro;

      this.form.dados_bancarios.banco = data.cf_banco;

      //this.form.dados_pessoais.estado_de_nascimento = data.cf_estado_de_nascimento;
      // setTimeout(() => {
      //this.form.dados_pessoais.cidade_de_nascimento = data.cf_cidade_de_nascimento;
      // }, 3000);

      this.count_dependentes = data.cf_count_dependentes;

      for (const i in data.dependentes) {
        const dependente = data.dependentes[i];
        this.add_dependente(dependente);
      }

      //POG para rodar somente depois que o formulário foi executado
      setTimeout(() => {
        // Loop nos dependentes
        for (const i in data.dependentes) {
          const dependente = data.dependentes[i];

          //Loop nas chaves do objeto dependente
          for (const key in dependente) {
            let id = `${key}_${i}`;
            let el = document.getElementById(id);

            // verifica se o existe
            if (el) {
              el.value = dependente[key];
            }
          }

          //POG: para o campo de dependete ir porque
          //a nomeclatura é diferente dos demais campos
          document.getElementById("cf_dependente_ir_" + i).value =
            dependente.cf_dependente_ir;
        }
      }, 3000);
    },
    // Método para detectar se o erro é relacionado a PDF protegido
    isPdfProtectedError(errorMessage) {
      const pdfErrorKeywords = [
        'pdf protegido',
        'pdf com senha',
        'senha do pdf',
        'documento protegido',
        'password protected',
        'encrypted pdf'
      ];
      
      if (!errorMessage) return false;
      
      const messageLower = errorMessage.toLowerCase();
      return pdfErrorKeywords.some(keyword => messageLower.includes(keyword));
    },
  },
};
</script>
<style lang="scss">
#CandidatoForm {
  .box-loading {
    position: relative;

    .loading {
      position: absolute;
      left: -34px;
      top: -2px;
      width: 31px;
    }
  }
  
  .help-text {
    font-size: 0.85em;
    color: #666;
    margin-top: 8px;
    font-style: italic;
    line-height: 1.4;
  }

  .skip-pdf-validation {
    background: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 6px;
    padding: 15px !important;
    margin: 15px 0;
    
    .checkbox-wrapper {
      display: flex;
      align-items: flex-start;
      gap: 10px;
      margin-bottom: 5px;
      
      input[type="checkbox"] {
        width: auto !important;
        height: auto !important;
        margin: 0;
        margin-top: 2px; // Alinha melhor com o texto
        transform: scale(1.2);
        accent-color: #fa4616;
        cursor: pointer;
        flex-shrink: 0; // Impede que o checkbox encolha
      }
      
      .checkbox-label {
        color: #495057;
        font-weight: 500;
        font-size: 15px;
        cursor: pointer;
        margin: 0;
        padding: 0;
        width: auto !important;
        line-height: 1.4;
      }
    }
    
    .help-text {
      margin-left: 0;
      color: #6c757d;
      font-size: 13px;
      padding-left: 30px; // Alinha com o texto do label
      line-height: 1.4;
    }
  }
}
</style>
